// GAPI actions
import axios from 'axios';
import types from '../../types';

export default {
  [types.GET_PLACE]: async (context, payload) => {
    try {
      const response = await axios.get(`${payload.url}${payload.output}${payload.parameters}${payload.apiKey}`);
      return response;
    } catch (e) {
      throw new Error(e);
    }
  },
};
